import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// Suppress ResizeObserver error before React initializes
if (typeof window !== 'undefined') {
  // Patch console methods
  const originalConsoleError = console.error;
  console.error = (...args) => {
    const message = args[0];
    if (typeof message === 'string' && message.includes('ResizeObserver loop')) {
      return;
    }
    originalConsoleError.apply(console, args);
  };

  const originalConsoleWarn = console.warn;
  console.warn = (...args) => {
    const message = args[0];
    if (typeof message === 'string' && message.includes('ResizeObserver loop')) {
      return;
    }
    originalConsoleWarn.apply(console, args);
  };

  // Patch window.onerror
  const originalError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    if (typeof message === 'string' && message.includes('ResizeObserver loop')) {
      return true;
    }
    if (originalError) {
      return originalError(message, source, lineno, colno, error);
    }
    return false;
  };

  // Add error event listener with capture
  window.addEventListener('error', function(e) {
    if (e.message && e.message.includes('ResizeObserver loop')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
    }
  }, true);

  // Patch ResizeObserver
  if (window.ResizeObserver) {
    const OriginalRO = window.ResizeObserver;
    window.ResizeObserver = class extends OriginalRO {
      constructor(callback) {
        super((entries, observer) => {
          try {
            callback(entries, observer);
          } catch (err) {
            if (err?.message?.includes('ResizeObserver loop')) {
              return;
            }
            throw err;
          }
        });
      }
    };
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
